exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-df61042c]  .el-upload--picture-card {\n  display: none;\n}\n.disabled[data-v-df61042c]  .el-upload__tip {\n  margin-top: -10px;\n}", ""]);

// exports
